import React, {Component} from 'react';
import {UrlBuilder} from "../../../core/url/UrlBuilder";
import Dialog from "@mui/material/Dialog";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import moment from "moment";
import Slide from "@mui/material/Slide";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import ColorSelector from "../../core/utils/ColorSelector";
import {ColorPicker} from "../../../core/colors/ColorPicker";
import {blue} from "@mui/material/colors";
import FitnessCenterIcon from "@mui/icons-material/FitnessCenter";

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

class RoutineNewOrEditFormBloop extends Component {
	constructor(props) {
		super(props);

		this.state = {
			routine: this.props.routine,
			isOpen: false,
			isSubmissionLoading: false,
			name: this.props.routine ? this.props.routine.name : '',
			description: this.props.routine ? this.props.routine.description : '',
			color: props.routine?.color ?? (props.routine ? ColorPicker.pick(props.routine.name) : blue[500]),
		};
	}

	componentWillReceiveProps(nextProps, nextContext) {
		if (this.state.isOpen !== Boolean(nextProps.isOpen)) {
			this.setState({
				isOpen: Boolean(nextProps.isOpen),
				routine: nextProps.routine,
				name: nextProps.routine ? nextProps.routine.name : '',
				color: nextProps.routine?.color ?? (nextProps.routine ? ColorPicker.pick(nextProps.routine.name) : blue[500]),
				description: nextProps.routine ? nextProps.routine.description : '',
			});
		}
	}

	submitWithEnter = (e) => {
		if (e.key === 'Enter') {
			this.submit(e);
		}
	}

	submit = async (event) => {
		event.preventDefault();

		this.setState({ isSubmissionLoading: true });

		let routineToSave = {
			Name: this.state.name,
			Description: this.state.description,
			Color: this.state.color,
			dateCreated: moment().format('L, h:mm:ss A')
		};

		if (this.state.routine) {
			routineToSave['id'] = this.state.routine.id;

			await fetch(UrlBuilder.routine.routinesApi(), {
				method: 'PUT',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(routineToSave)
			})
				.then(response => response.json())
				.then(routine => this.props.closeSelfFunc(true));
		} else {
			await fetch(UrlBuilder.routine.routinesApi(), {
				method: 'POST',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(routineToSave)
			})
				.then(this.props.closeSelfFunc);
		}

		this.setState({ isSubmissionLoading: false });
	}

	updateStateInputValues = (event) => {
		let state = {
			[event.target.name]: event.target.value,
		};

		if (event.target.name === 'name') {
			state['color'] = ColorPicker.pick(event.target.value);
		}

		this.setState(state);
	}

	updateStateInputColorValue = (color) => {
		this.setState({ color: color });
	}

	render() {
		const isEditing = !!this.state.routine;

		return (
			<Dialog
				open={this.state.isOpen}
				onClose={() => this.props.closeSelfFunc(false)}
				TransitionComponent={Transition}
				fullWidth
				maxWidth="xs"
				PaperProps={{ sx: { borderRadius: 3 } }}
			>
				{/* Header */}
				<Box sx={{ px: 2.5, pt: 2.5, pb: 0.5 }}>
					<Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 0.5 }}>
						{this.state.name ? (
							<Box sx={{
								width: 38, height: 38, borderRadius: '50%',
								bgcolor: this.state.color,
								display: 'flex', alignItems: 'center', justifyContent: 'center',
								flexShrink: 0, transition: 'background-color 0.2s',
							}}>
								<Typography sx={{ color: 'white', fontWeight: 700, fontSize: 16 }}>
									{this.state.name.charAt(0).toUpperCase()}
								</Typography>
							</Box>
						) : (
							<Box sx={{
								width: 38, height: 38, borderRadius: '50%',
								bgcolor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.06)',
								display: 'flex', alignItems: 'center', justifyContent: 'center',
								flexShrink: 0,
							}}>
								<FitnessCenterIcon sx={{ fontSize: 20, color: 'text.disabled' }} />
							</Box>
						)}
						<Typography variant="h6" sx={{ fontWeight: 700, fontSize: 19 }}>
							{isEditing ? 'Edit Routine' : 'New Routine'}
						</Typography>
					</Box>
				</Box>

				{/* Form */}
				<Box sx={{ px: 2.5, pt: 1.5, pb: 1 }}>
					<Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
						<TextField
							required
							fullWidth
							label="Name"
							name="name"
							value={this.state.name}
							onChange={this.updateStateInputValues}
							onKeyPress={this.submitWithEnter}
							placeholder="e.g. Upper Body"
							size="small"
							autoFocus={!isEditing}
						/>
						<TextField
							fullWidth
							name="description"
							label="Description (optional)"
							type="text"
							value={this.state.description}
							onChange={this.updateStateInputValues}
							onKeyPress={this.submitWithEnter}
							placeholder="e.g. My summer upper body routine"
							size="small"
						/>
					</Box>

					{/* Color */}
					<Box sx={{ mt: 2 }}>
						<Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5, fontSize: 11, display: 'block', mb: 1 }}>
							Color
						</Typography>
						<ColorSelector color={this.state.color} updateColorValueParentFunc={this.updateStateInputColorValue} />
					</Box>
				</Box>

				{/* AI CTA */}
				{!isEditing && this.props.onUseAi && (
					<Box
						onClick={() => {
							this.props.closeSelfFunc(false);
							this.props.onUseAi();
						}}
						sx={(theme) => ({
							mx: 2.5, mb: 1.5, mt: 0.5,
							p: 1.5,
							display: 'flex',
							alignItems: 'center',
							gap: 1.5,
							borderRadius: 2,
							cursor: 'pointer',
							background: `linear-gradient(135deg, ${theme.palette.secondary.main}18, ${theme.palette.primary.main}18)`,
							border: `1px solid ${theme.palette.secondary.main}40`,
							transition: 'all 0.2s',
							'&:hover': {
								background: `linear-gradient(135deg, ${theme.palette.secondary.main}30, ${theme.palette.primary.main}30)`,
								border: `1px solid ${theme.palette.secondary.main}80`,
							},
						})}
					>
						<AutoAwesomeIcon color="secondary" fontSize="small" />
						<Box>
							<Typography variant="body2" sx={{ fontWeight: 600, lineHeight: 1.3 }}>
								Build a full program with AI
							</Typography>
							<Typography variant="caption" color="text.secondary">
								Describe your goals and get a complete routine plan
							</Typography>
						</Box>
					</Box>
				)}

				{/* Actions */}
				<DialogActions sx={{ px: 2.5, py: 2, gap: 1 }}>
					<Button
						variant="outlined"
						onClick={() => this.props.closeSelfFunc(false)}
						sx={{ textTransform: 'none' }}
					>
						Cancel
					</Button>
					<Button
						variant="contained"
						color="secondary"
						onClick={this.submit}
						disabled={this.state.isSubmissionLoading || this.state.name.trim() === ''}
						sx={{ textTransform: 'none', fontWeight: 600, px: 3 }}
					>
						{this.state.isSubmissionLoading ? (
							<><CircularProgress size={16} color="inherit" sx={{ mr: 1 }} /> Saving...</>
						) : (
							isEditing ? 'Save Changes' : 'Create Routine'
						)}
					</Button>
				</DialogActions>
			</Dialog>
		);
	}
}

export default RoutineNewOrEditFormBloop;
